var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "section_gap_x section_gap_y" }, [
    _c("div", { staticClass: "img_wraper" }, [
      _c("img", { attrs: { src: _vm.catelogue.image_link, alt: "" } })
    ]),
    _vm._v(" "),
    _c("div", [
      _c("div", { staticClass: "title_header section_gap_y" }, [
        _c("p", { staticClass: "shop_label sp_title_lg" }, [
          _vm._v(_vm._s(_vm.catelogue.title))
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "sp_title_md description" }, [
          _vm._v(_vm._s(_vm.catelogue.description))
        ])
      ])
    ]),
    _vm._v(" "),
    _vm.catelogue.variants
      ? _c("div", [
          _c(
            "section",
            { staticClass: "variant_grid_container" },
            [
              _c("div", { staticClass: "grid_system grid_header" }, [
                _c("div", [
                  _vm._v(
                    _vm._s(_vm.$t("CATELOGUE_ITEM.VARIANT.TABLE_HEADER.TITLE"))
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    _vm._s(_vm.$t("CATELOGUE_ITEM.VARIANT.TABLE_HEADER.PRICE"))
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    _vm._s(
                      _vm.$t("CATELOGUE_ITEM.VARIANT.TABLE_HEADER.QUANTITY")
                    )
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    _vm._s(
                      _vm.$t("CATELOGUE_ITEM.VARIANT.TABLE_HEADER.TOTAL_PRICE")
                    )
                  )
                ])
              ]),
              _vm._v(" "),
              !_vm.isCatalogLoading
                ? _vm._l(_vm.catelogue.variants, function(variant, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "grid_system grid_data" },
                      [
                        _c("div", { staticClass: "word_break" }, [
                          _vm._v(_vm._s(variant.display_title))
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "align_right" }, [
                          _vm._v(_vm._s(variant.price))
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _c("div", { staticClass: "controll_btns" }, [
                            _c(
                              "span",
                              {
                                staticClass: "controll_icon",
                                on: {
                                  click: function($event) {
                                    return _vm.decreaseQuantity(index)
                                  }
                                }
                              },
                              [
                                _c("fluent-icon", {
                                  attrs: { icon: "subtract" }
                                })
                              ],
                              1
                            ),
                            _vm._v(
                              "\n                " +
                                _vm._s(variant.orderQuantity) +
                                "\n                "
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "controll_icon",
                                on: {
                                  click: function($event) {
                                    return _vm.increaseQuantity(index)
                                  }
                                }
                              },
                              [_c("fluent-icon", { attrs: { icon: "add" } })],
                              1
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "align_right" }, [
                          _vm._v(
                            _vm._s(
                              (variant.price * variant.orderQuantity).toFixed(2)
                            )
                          )
                        ])
                      ]
                    )
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.isCatalogLoading ? _c("loader-round") : _vm._e(),
              _vm._v(" "),
              !_vm.isCatalogLoading && !_vm.catelogue.variants.length
                ? _c("p", { staticClass: "no_item" }, [
                    _vm._v("No product available")
                  ])
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          _c("div", [
            _c(
              "div",
              { staticClass: "action_btns section_gap_y" },
              [
                _c(
                  "shop-button",
                  {
                    attrs: {
                      disabled:
                        _vm.isOrderButtonDisabled ||
                        _vm.isAddToCartDisabled ||
                        _vm.isNotInBusinessHours
                    },
                    on: { click: _vm.addToCartHandler }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t("CATELOGUE_ITEM.VARIANT.BTNS.ADD_TO_CART")
                        ) +
                        "\n        "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "shop-button",
                  {
                    attrs: {
                      disabled:
                        _vm.isOrderButtonDisabled ||
                        _vm.isAddToCartDisabled ||
                        _vm.isNotInBusinessHours
                    },
                    on: { click: _vm.orderNowhandler }
                  },
                  [_vm._v("\n          Continue\n        ")]
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm.isNotInBusinessHours
              ? _c("p", { staticStyle: { "text-align": "center" } }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t("CATELOGUE_ITEM.VARIANT.BTNS.BUSINESS_HOUR_MSG")
                    )
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.isOrderExist
              ? _c("p", { staticStyle: { "text-align": "center" } }, [
                  _vm._v(
                    _vm._s(_vm.$t("CATELOGUE_ITEM.VARIANT.BTNS.ORDER_EXIST"))
                  )
                ])
              : _vm._e()
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }